export const validateName = (value) => {
	const regex = /^[a-zA-Z0-9]+( [a-zA-Z0-9]+)*$/ // Allows alphanumeric with single spaces
	return regex.test(value) && value.split(' ').length <= 60
}
export const validateEmail = (value) => {
	const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/ // Validates basic email structure
	const numericCount = (value.match(/\d/g) || []).length
	return regex.test(value) && value.length <= 30 && numericCount <= 6
}

export const validateMobile = (value) => {
	const mobileNumberRegex = /^(?!0{10})\d{10}$/
	return mobileNumberRegex.test(value) // Returns true if value is exactly 10 digits
}

export const validateAddressLine1 = (value) => {
	const regex = /^[a-zA-Z0-9\-\,\/\_\(\)]+( [a-zA-Z0-9\-\,\/\_\(\)]+)*$/ // Alphanumeric, special characters, and single spaces
	return regex.test(value) && value.length <= 100
}
export const validateAddressLine2 = (value) => {
	const regex = /^[a-zA-Z0-9\-\,\/\_\(\)]+( [a-zA-Z0-9\-\,\/\_\(\)]+)*$/ // Alphanumeric and allowed special characters
	return value ? regex.test(value) && value.length <= 100 : true
}
export const validateLandmark = (value) => {
	const regex = /^(?=[a-zA-Z ]*(\d{1,2})?[a-zA-Z ]*$)(?!.* {2})[a-zA-Z ]*$/ // Allows alphabets, single space, and up to 2 numbers
	return regex.test(value) && value.length <= 100 && value.split(' ').length <= 30
}
export const validateCity = (value) => {
	const regex = /^[a-zA-Z]+( [a-zA-Z]+)*$/ // Only alphabets and single space
	return regex.test(value) && value.split(' ').length <= 15
}
export const validatePincode = (pincode, isIndia) => {
	if (isIndia) {
		// For India: Only 6 numericals, and not "000000"
		return /^(?!000000)\d{6}$/.test(pincode)
	} else {
		// Global: Alphanumeric up to 9 characters, can include ONE "-" and ONE space
		return /^(?=.{1,9}$)[a-zA-Z0-9]+(?:[-\s][a-zA-Z0-9]+)?$/.test(pincode)
	}
}
export const validateGST = (value) => {
	const regex = /^\d{2}[A-Z]{5}\d{4}[A-Z]\d[Z][A-Z\d]$/ // GST structure
	return regex.test(value) && value.length === 15
}
export const validateUserID = (value) => {
	const regex = /^S[a-zA-Z0-9]{5,11}$/ // Starts with 'S', alphanumeric, length 6-12
	const nonStartingAlphabets = value.slice(1).match(/[a-zA-Z]/g) || [] // Check alphabet count after 'S'

	return regex.test(value) && nonStartingAlphabets.length === 1 // Ensure exactly 1 random alphabet apart from 'S'
}
export const validateAmount = (value) => {
	const regex = /^\d+$/ // Allows only numerical values
	return regex.test(value)
}
export const validateTransactionPassword = (value) => {
	const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{1,15}$/
	// Requires at least one lowercase letter, one uppercase letter, one number, and one special character
	return regex.test(value) && value.length <= 15
}
